import React, { useContext } from 'react';
import { useStyletron } from 'baseui';
import { Heading, HeadingLevel } from 'baseui/heading';
import { FilePill } from '@gtintel/platform-atoms';
import { ProjectFilesContext } from '../../ProjectApp/context';
import FileUpload from '../FileUpload';
export default () => {
  const {
    reportTemplate,
    addAttachment,
    sampleReport,
    removeAttachment
  } = useContext(ProjectFilesContext);
  const [css] = useStyletron();
  return <div className={css({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '24px',
    marginBottom: '24px',
    '@media (max-width: 768px)': {
      gridTemplateColumns: '1fr'
    }
  })}>
      <div>
        <HeadingLevel>
          <Heading styleLevel={2}>Report Template</Heading>
        </HeadingLevel>
        {!reportTemplate() ? <span data-testid="project-report-template-upload">
            <FileUpload handleUpload={async file => {
          addAttachment(file, 'reportTemplate');
        }} disabled={!!reportTemplate()} overrides={{
          Root: {
            style: {
              maxWidth: '1000px'
            }
          }
        }} />
          </span> : <FilePill key={reportTemplate().id} file={reportTemplate()} closeButtonFunc={() => removeAttachment(reportTemplate().id, 'reportTemplate')} />}
      </div>
      <div>
        <HeadingLevel>
          <Heading styleLevel={2}>Report Sample</Heading>
        </HeadingLevel>
        {!sampleReport() ? <span data-testid="project-sample-report-upload">
            <FileUpload handleUpload={async file => {
          addAttachment(file, 'sampleReport');
        }} disabled={!!sampleReport()} overrides={{
          Root: {
            style: {
              maxWidth: '1000px'
            }
          }
        }} />
          </span> : <FilePill key={sampleReport().id} file={sampleReport()} closeButtonFunc={() => removeAttachment(sampleReport().id, 'sampleReport')} />}
      </div>
    </div>;
};